import { User } from '../accounts/User';
import { Label } from '../labels/labels';
import {
  QualificationTrainingsStatus,
  UpdateTrainingQualificationStatus,
} from './QualificationTrainingsStatus';
import { QualificationV2 } from './QualificationV2';

export interface QualificationTrainings {
  id: string;
  createdAt: string;
  createdById: string;
  deletedAt: string | null;
  deletedById: string | null;
  labels: Label[];
  notes: string | null;
  qualificationId: string;
  userId: string;
  user: Pick<User, 'firstName' | 'lastName'>;
  updatedByProvider: string | null;
  updatedById: string | null;
  status: QualificationTrainingsStatus;
  qualifications: Pick<
    QualificationV2,
    'id' | 'nameEn' | 'nameDe' | 'nameFr' | 'namePl'
  >[];
  qualificationTrainingAttachments: QualificationTrainingAttachmentV2[];
  organizationalUnitQualificationTrainingProviderId: string;
  organizationalUnitQualificationTrainingProvider: {
    qualificationTrainingProvider: {
      name: string;
      providerType: QualificationTrainingProviderType;
    };
  };
  name: string;
  qualificationName: string;
  routeRecord?: RouteRecord;
}

export enum QualificationTrainingProviderType {
  Digital = 'digital',
  Manual = 'manual',
  Custom = 'custom',
}

export interface QualificationTrainingAttachmentV2 {
  id: string;
  s3Path: string;
  fileName: string;
}

export type QualificationTrainingsWithQ =
  QualificationTrainingsWithQualification;
export type QualificationTrainingsWithQualification = QualificationTrainings & {
  qualification: QualificationTrainings[];
};

export interface BulkUpdateTrainingQualificationV2Dto {
  items: UpdateTrainingQualificationV2Dto[];
}

export interface UpdateTrainingQualificationV2Dto {
  id: string;
  name?: string;
  notes?: string | null;
  labels?: Pick<Label, 'id'>[] | null;
  status?: UpdateTrainingQualificationStatus;
}

interface RouteRecord {
  id: string;
  endLocation: LocationRecord;
  startLocation: LocationRecord;
  viaLocations: LocationRecord[];
  status: string | null;
  updatedAt: string | null;
  updatedById: string | null;
  updatedByProvider: string | null;
}
interface LocationRecord {
  id: string;
  name: string;
  locationCode: string;
}
